import Glide, {
	Controls,
	Breakpoints,
	Autoplay,
	Swipe,
} from '@glidejs/glide/dist/glide.modular.esm';
import _ from 'lodash';

const Sliders = {
	init() {
		function buildSlider(element) {
			const window_width =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			const margin = window_width / 10;
			let glide = new Glide(element, {
				hoverpause: false,
				type: 'slider',
				perView: 2,
				autoplay: false,
				bound: true,
				animationDuration: 700,
				gap: 60,
				animationTimingFunc: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
				peek: {
					before: margin,
					after: margin + margin,
				},

				breakpoints: {
					1115: {
						perView: 2,
						gap: 40,
						peek: {
							before: '60px',
							after: '60px',
						},
					},
					960: {
						perView: 2,
						gap: 60,
						peek: {
							before: '40px',
							after: '60px',
						},
					},
					880: {
						perView: 1,
						gap: 70,
						peek: {
							before: '40px',
							after: '60px',
						},
					},
					820: {
						perView: 1,
						gap: 20,
						peek: {
							before: '20px',
							after: '60px',
						},
					},
				},
			});
			return glide;
		}
		// var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		const glides = document.querySelectorAll('.glide');
		if (glides) {
			glides.forEach((el) => {
				var _glide = buildSlider(el);

				_glide.mount({ Controls, Breakpoints, Autoplay, Swipe });
				window.addEventListener('resize', () => {
					setTimeout(() => {
						_glide.destroy();
						_glide = buildSlider(el);
						_glide.mount({
							Controls,
							Breakpoints,
							Autoplay,
							Swipe,
						});
					}, 1000);
				});
			});
		}

		const iconglides = document.querySelectorAll('.icon_glide');
		if (iconglides) {
			iconglides.forEach((el) => {
				var _glide = new Glide(el, {
					hoverpause: false,
					type: 'slider',
					perView: 5,
					autoplay: false,

					animationDuration: 700,
					gap: 30,
					animationTimingFunc:
						'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
					breakpoints: {
						1200: {
							gap: 10,
						},
						820: {
							perView: 1,
							gap: 20,
							peek: {
								before: '20px',
								after: '20px',
							},
						},
					},
				});

				_glide.mount({ Controls, Breakpoints, Autoplay, Swipe });
				window.addEventListener('resize', () => {
					setTimeout(() => {
						_glide.go('=0');
					}, 1000);
				});
			});
		}

		const amenityglides = document.querySelectorAll('.amenity_glide');
		if (amenityglides.length > 0) {
			amenityglides.forEach((el) => {
				var _glide = new Glide(el, {
					hoverpause: false,
					type: 'slider',
					perView: 3,
					autoplay: false,
					bound: true,
					animationDuration: 700,
					gap: 20,
					animationTimingFunc:
						'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
					peek: {
						before: '20px',
						after: '20px',
					},
					breakpoints: {
						820: {
							perView: 1,
							peek: {
								before: '20px',
								after: '80px',
							},
						},
						1400: {
							perView: 2,
							peek: {
								before: '20px',
								after: '80px',
							},
						},
					},
				});

				_glide.mount({ Controls, Breakpoints, Autoplay, Swipe });
				window.addEventListener('resize', () => {
					setTimeout(() => {
						_glide.go('=0');
					}, 1000);
				});
			});
		}
	},
};

export default Sliders;
